export { LoyaltylionStaticRewards } from './LoyaltylionStaticRewards';
